import React, { createContext, useState } from "react";
import PropTypes from "prop-types";
import useFetch from "./hooks/useFetch";
import { getCurrentMonth } from "./helpers/date";

const Context = createContext();

export const EventsProvider = ({ children, indexPage, language }) => {
	const [params, setParams] = useState({month: getCurrentMonth().monthYear, lang: language});
	const [items, message, datesWithEvents] = useFetch(indexPage, params);
	const [selectedDate, setSelectedDate] = useState(null);

	const labelText = () => {
		if (language === "en"){
			return `Select a location`;
		}
		return `Sélectionner un lieu`;
	}
	const [label, setLabel] = useState(labelText());

	const data = {
		// data or state to be passed on to child components
		language,
		indexPage,
		items,
		message,
		params,
		datesWithEvents,
		selectedDate,
		label,
		labelText,
	};

	const actions = {
		// handlers and mutation functions that would be passed down to components
		setParams,
		setSelectedDate,
		setLabel,
	};

	return (
		<Context.Provider value={{ actions, data }}>{children}</Context.Provider>
	);
};

EventsProvider.propTypes = {
	children: PropTypes.any,
	indexPage: PropTypes.string,
	language: PropTypes.string,
}

export default Context;